import * as React from "react";
import "./movieItemViewStyles.css";
export var MovieLabelView = function (_a) {
    var movie = _a.movie;
    if (!movie.label) {
        return null;
    }
    return (React.createElement("p", { className: "movie-label movie-label--" + movie.label.color }, movie.label.name));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MovieLabelView.tsx
// module id = 116
// module chunks = 1